type InputLocation = {
  name: string;
  latitude: string;
  longitude: string;
  countryCode: string;
};

type OutputLocation = {
  name: string;
  countryCode: string;
  latitude: string | null;
  longitude: string | null;
};

export function TransformLocations(data: InputLocation[]): OutputLocation[] {
  return data.map((item) => {
    const cityName = item.name.split(",")[0].trim();

    return {
      name: cityName,
      countryCode: item.countryCode,
      latitude: item.latitude || null,
      longitude: item.longitude || null,
    };
  });
}
